import FirestoreDataClass from "./_baseClasses";

export default class GroundTruth extends FirestoreDataClass {
  static collectionName = "ground_truths";

  get $duration() {
    return this.get('information.duration_seconds', 0)
  }
}
